/** View */
export const SET_VIEW = 'SET_VIEW';
export const SET_ALERT = 'SET_ALERT';
export const RESET_STATE = 'RESET_STATE';

/** Field **/
export const SET_VALUE = 'SET_VALUE';
export const SET_FIELDS = 'SET_FIELDS';
export const ADD_VALUE = 'ADD_VALUE';
export const REMOVE_VALUE = 'REMOVE_VALUE';
export const ADD_ENUM_OPTIONS = 'ADD_ENUM_OPTIONS';
export const SET_DISABLED = 'SET_DISABLED';

/** Object **/
export const SET_URI = 'SET_URI';
export const SET_OBJECT = 'SET_OBJECT';
export const SET_PARAMETERS = 'SET_PARAMETERS';
export const SET_LOADING = 'SET_LOADING';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_OBJECT_COUNT = 'SET_OBJECT_COUNT';

/** Resources */
export const CREATE_RESOURCE = 'CREATE_RESOURCE';
export const EDIT_RESOURCE = 'EDIT_RESOURCE';
export const REMOVE_RESOURCE = 'REMOVE_RESOURCE';

// main image
export const SET_PRIMARY_VERSION = 'SET_PRIMARY_VERSION';

// remember scroll pos eg. modal navigation
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';

// validation
export const SET_VALIDATED = 'SET_VALIDATED';
export const RESET_VALIDATION = 'RESET_VALIDATION';
export const SET_SAVED = 'SET_SAVED';
export const SET_REQUIRED = 'SET_REQUIRED';

// modal
export const ADD_RESOURCE = 'ADD_RESOURCE';
export const CLOSE_RESOURCE = 'CLOSE_RESOURCE';
export const SAVE_RESOURCE = 'SAVE_RESOURCE';
export const SET_FILE = 'SET_FILE';
export const SET_TEMPLATE = 'SET_TEMPLATE';
export const SET_ACTIVE_RESOURCE = 'SET_ACTIVE_RESOURCE';
export const OPEN_MODAL = 'TOGGLE_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const RETURN_CALLBACK = 'RETURN_CALLBACK';
export const CLOSE_ALERT = 'CLOSE_ALERT';
export const SET_SAVE_DISABLED = 'SET_SAVE_DISABLED';
export const ADD_STATEMENT_TEXT = 'ADD_STATEMENT_TEXT';
export const ADD_STATEMENT_COMMENT = "ADD_STATEMENT_COMMENT";
export const CAN_LINK_MULTIPLE_OBJECTS = 'CAN_LINK_MULTIPLE_OBJECTS';
export const SET_CHECKED_URIS = 'SET_CHECKED_URIS';

// mass edit
export const TOGGLE_ADD_FIELD = 'TOGGLE_ADD_FIELD';
export const TOGGLE_ALLOW_FIELD = 'TOGGLE_ALLOW_FIELD';
export const RESET_CHECKBOXES = 'RESET_CHECKBOXES';
export const MASSEDIT_ALLOW = 'MASSEDIT_ALLOW_';
export const MASSEDIT_ADD = 'MASSEDIT_ADD_';

//visibility
export const SET_VISIBILITY = 'SET_VISIBILITY';
export const UPDATE_VISIBILITY = 'UPDATE_VISIBILITY';